import type { ReactNode } from 'react';
import { DS2 } from '../../theme/designTokens';

/**
 * DS2 Auth-family heading — Montserrat 700 32.44/39 ×0.75, letter-spacing
 * -0.48px. Extracted from ForgotPasswordScreen (its "Reset Password"/
 * "Create a new password"/"Check your email" headings); same spec Figma
 * gives Login's "Welcome Back!" and the email-registration flow's headings.
 */
export function AuthHeading({ children }: { children: ReactNode }) {
  return (
    <h1
      style={{
        margin:        '18px 0 0',
        fontFamily:    DS2.font.heading,
        fontWeight:    700,
        fontSize:      24.33,
        lineHeight:    '29.25px',
        letterSpacing: '-0.48px',
        textAlign:     'center',
        color:         '#FFFFFF',
      }}
    >
      {children}
    </h1>
  );
}
